const c=i=>{const n=["B","KB","MB","GB","TB"],r=t=>{const s=i/1024**t,o=t===0;return s.toFixed(o?0:2)+n[t]};for(let t=0;t<n.length;t++){const s=i/1024**t,o=t===n.length-1;if(s<1)return r(t-1);if(o)return r(t)}};export{c as formatFileSize};
//# sourceMappingURL=formatFileSize.js.map
